import cx from 'clsx';
import React from 'react';
import type { Control } from 'react-hook-form';

import Switch from '@components/uikit/Switch/Switch';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  showCheckbox?: boolean;
  checkboxLabel?: string;
  control: Control;
  action: string;
  allTimeChecked: boolean;
  aiTypeFilter: boolean;
}

const LocationSelectSwitcher = ({
  showCheckbox,
  checkboxLabel,
  control,
  action,
  allTimeChecked,
  aiTypeFilter,
}: IProps) => {
  const { t } = useTranslation();

  const shouldRender =
    showCheckbox &&
    (action === 'exportCostSavings' || (action === 'exportActiveActionItems' && !allTimeChecked));

  if (!shouldRender) return null;

  return (
    <div className={cx(style.closedAiCheckbox, { [style.checkboxWithTabs]: aiTypeFilter })}>
      <Switch name="checkboxValue" control={control} label={t(checkboxLabel)} type="woHelperText" />
    </div>
  );
};

export default LocationSelectSwitcher;
